import { useSoftphoneActionsSafe } from '../SoftphoneProvider';
import { useSoftphoneStore } from '../store/softphoneStore';

/**
 * Safe variant of `useSoftphone` for components that may render outside
 * a `<SoftphoneProvider>` (e.g., the click-to-dial widget, which lives
 * everywhere a phone number renders — including pages where the
 * softphone isn't mounted because the tenant doesn't have it
 * provisioned, or the rep hasn't opted in).
 *
 * Returns null when no provider is mounted. Reads non-call store state
 * unconditionally — Zustand stores work without React context, so the
 * registration/role flags stay observable even when the provider is
 * absent (they're just always at their initial values).
 */
export function useSoftphoneSafe() {
	const actions = useSoftphoneActionsSafe();
	const isRegistered = useSoftphoneStore((s) => s.isRegistered);
	const role = useSoftphoneStore((s) => s.role);
	const currentCall = useSoftphoneStore((s) => s.currentCall);

	if (actions == null) {
		return null;
	}

	return {
		role,
		isLeader: role === 'leader',
		isRegistered,
		currentCall,
		dial: actions.dial,
	};
}
